import React from "react"
import PropTypes from "prop-types"

import Typograph from "components/Typograph"
import ProfitCards from "./ProfitCards"

import styles from "../styles.css"

const Benefits = ({ profitCards }) => {
  return (
    <section className={styles.sectionBenefits}>
      <Typograph
        htmlTag="h2"
        size="extra_large"
        color="outer_space"
        weight="bold"
      >
        Benefícios exclusivos para você
      </Typograph>
      <ProfitCards cards={profitCards} />
    </section>
  )
}

Benefits.propTypes = {
  profitCards: PropTypes.array
}

export default Benefits



// WEBPACK FOOTER //
// ./src/scenes/AlgarForever/components/Benefits.js